(function () {
    'use strict';

    angular.module("imApp").factory("custactCalcPickSelectService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 875,
                    parameters: parms || {}
                });
            },
            listPickPackages: function (parms) {
                return $ihttp.post({
                    method: 871,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
